import React, {useEffect, useState} from 'react'
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import "./paymentProcessing.scss"
import PaymentStatusAPI from '../../services/PaymentStatus/PaymentStatus';
import ModalPopUp from '../../components/modal/modal';
import { pageUrl } from '../../utils/pageConstant';
import SuccessIcon from "../../assets/success.json";
import Success from "../../assets/PaymentSuccess.json";
import Failed from "../../assets/PaymentFail.json";
import ErrorIcon from "../../assets/error.json";

function PaymentProcessing() {
    const [orderID, setOrderID] = useState();
    const [isSuccessOrder, setIsSuccessOrder] = useState(false);
    const [isOrderPending, setIsOrderPending] = useState(false);
    const [message, setMessage] = useState({});
    const [statusIcon, setStatusIcon] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const paymentParams = {
          bankName: searchParams.get("bankName") || "",
          paymentRefNumber: searchParams.get("hdnRefNumber") || "",
          payment_id: searchParams.get("razorpay_payment_id") || "",
          amount: searchParams.get("amount") || "",
          type: searchParams.get("paymentType") || "",
          reference_id: searchParams.get("razorpay_payment_link_reference_id") || "",
          link_id: searchParams.get("razorpay_payment_link_id") || "",
          status: searchParams.get("razorpay_payment_link_status") || "",
          signature: searchParams.get("razorpay_signature") || "",
          order_id: searchParams.get("order_id") || ""
        };

        setOrderID(paymentParams.paymentRefNumber || paymentParams.order_id);

        const paymentStatus = searchParams.get("payment_status");
        if(paymentStatus === "failed"){
          setIsModalOpen(true);
          setIsSuccessOrder(false);
          setStatusIcon({ icon: Failed });
          setMessage({
            title: "Failed!",
            text: "Payment Failed, Please try again.",
          });
          return;
        }

        if (paymentParams.paymentRefNumber || paymentParams.order_id) {
          console.log("Calling getPaymentStatus function!!");
          getPaymentStatus(paymentParams);
        }
    }, []);

    const getPaymentStatus = async (params) => {
      console.log("Inside getPaymentStatus function!!");
      try {
        const responseData = await PaymentStatusAPI(params);
        setIsModalOpen(true);
        console.log("getPaymentStatus API response :", responseData);
        if (responseData?.status === "COMPLETE") {
          setStatusIcon({ icon: Success });
          setIsSuccessOrder(true);
          setMessage({
            title: "Success",
            text: "",
          });
        } else if (responseData?.status === "payment progress") {
          setStatusIcon({ icon: Failed });
          setIsOrderPending(true);
          setMessage({
            title: "Pending!",
            text: "Payment is in progress",
          });
        } else {
          setIsSuccessOrder(false);
          setStatusIcon({ icon: Failed });
          setMessage({
            title: "Failed!",
            text: "Payment Failed, Please try again.",
          });
        }
      } catch (error) {
        console.log("PaymentStatusAPI---", error);
        setIsSuccessOrder(false);
        setStatusIcon({ icon: Failed });
        setMessage({
          title: "Error!",
          text: "Something went wrong.",
        });
      }
    };

    const handleCloseModal = () => {
      setIsModalOpen(false);
      if (isSuccessOrder) {
        // console.log("Order ID passed to location state : ", orderID);
        navigate(pageUrl.PAYMENT_SUMMARY, { state: { orderID: orderID } });
      } else if(isOrderPending){
        navigate("/outlet-list");
      }else {
        navigate("/pay-bill");
      }
    };

    const handleAbort = () => {
      navigate("/outlet-list");
    }

    return (
        <div className="payment-processing">
            <div className="loader"></div>
            <h2>Processing Your Payment</h2>
            <p>Please wait while we complete your transaction.</p>
            <p>This may take a few moments. Do not refresh or close this page.</p>
            <div className='abort-section'>
              <p className='abort-text'>If not redirected automatically,</p>
              <span className='abort-link' onClick={handleAbort}>Click Here..</span>
            </div>
            {isModalOpen && (
                <ModalPopUp
                isOpen={isModalOpen}
                handleModalClose={handleCloseModal}
                message={message}
                icon={statusIcon.icon}
                />
            )}
        </div>
    )
}

export default PaymentProcessing